import { HttpService } from '@/data/http/http-service';
import { getTagDtoSchema } from '@/data/http/tags/tag.dto.schema.ts';
import { TagMapper } from '@/data/http/tags/tag.mapper.ts';
import { Tag } from '@/domain/tags/entities/tag.entity.ts';
import { TagGateway } from '@/domain/tags/gateways/tag.gateway.ts';

export class ApiTagHttpGateway implements TagGateway {
  private http = new HttpService({
    baseURL: import.meta.env.VITE_API_CONNECT,
  });

  async getTags(): Promise<Array<Tag>> {
    const url = '/tags';
    const response = await this.http.get(url);
    const result = getTagDtoSchema.safeParse(response.data);
    if (!result.success) {
      console.error(result.error);
      throw result.error;
    }
    const result2 = getTagDtoSchema.safeParse(response.data);
    if (result2.success) {
      // case with one organisation
      return result2.data.data;
    } else {
      // case with no organisation
      return [];
    }
  }

  async createTag(tagName: string): Promise<Tag> {
    const url = '/tags';
    const data = TagMapper.entityToDto(tagName);
    const response = await this.http.post(url, data);
    if (response.status === 201) {
      return TagMapper.dtoToEntity(response.data);
    } else {
      throw 'error on creation';
    }
  }
}
